<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/require-component-is -->
<template>
  <div class="oms-header">
    <!-- 其他功能依次排（消息等，排除公司名单独定位） -->
    <template v-for="(item) in otherModules">
      <component :is="item" :key="item" />
    </template>
    <ClearCache v-if="false" />
    <!-- 公司名：居右第二个 -->
    <TenantSwitch v-if="showTenant" />
    <!-- 用户信息：居右第一个 -->
    <SignOut v-if="webSource !== 'dingtalk'" @eventsClick="eventsClick" />
    <div v-if="webSource == 'dingtalk'" class="debug-btn" @click="handleTripleClick">
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import Msg from './children/Msg/index.vue';
import Work from './children/Work.vue';
import Knowledge from './children/Knowledge.vue';
import TenantSwitch from './children/TenantSwitch.vue';
import SignOut from './children/SignOut.vue';
// import MqttClient from '../utils/MqttClient';
import Baseunified from '../utils/micro/baseunified';
import CallBox from './children/CallBox.vue';
import ClearCache from './children/ClearCache.vue';
import VConsole from '@/utils/vconsole.min.js';

export default {
  name: 'OmsHeader',
  components: {
    Msg, Work, Knowledge, TenantSwitch, SignOut, CallBox, ClearCache,
  },
  data() {
    return {
      collapsed: false,
      headerModel: null,
      businessHeader: {
        left: [],
        right: [],
      },
      webSource: localStorage.getItem('webSource') || '', // 获取当前浏览器环境来源
      clickTimes: 0, // 记录点击次数
      lastClickTime: 0, // 上次点击时间
      showVConsole: false,
    };
  },
  computed: {
    // 公司名(TenantSwitch)单独定位到居右第二，其余模块依次排在左侧
    otherModules() {
      const all = [
        ...(this.businessHeader.left || []),
        ...(this.businessHeader.right || []),
      ];
      return all.filter((m) => m !== 'TenantSwitch');
    },
    showTenant() {
      const all = [
        ...(this.businessHeader.left || []),
        ...(this.businessHeader.right || []),
      ];
      return all.includes('TenantSwitch');
    },
  },
  created() {
    this.headerModel = new Baseunified();
    this.businessHeader = this.headerModel.showHeaderModule();
  },
  mounted() {
    // 从localStorage检查是否需要显示vConsole并初始化
    if (this.webSource === 'dingtalk' && localStorage.getItem('showVConsole') === '1') {
      this.initVConsole();
    }
  },
  methods: {
    eventsClick() {
      this.collapsed = !this.collapsed;
      this.$emit('onClick', this.collapsed);
      // eslint-disable-next-line no-undef
      mainBus.$emit('collapsed-click', this.collapsed);
    },
    // 处理三连击事件
    handleTripleClick() {
      const currentTime = new Date().getTime();
      if (currentTime - this.lastClickTime > 1000) { // 如果距离上次点击超过1秒，则重置计数
        this.clickTimes = 0;
      }

      this.clickTimes++;
      this.lastClickTime = currentTime;

      if (this.clickTimes >= 3) {
        this.clickTimes = 0; // 重置计数
        this.switchShowVConsole(); // 调用切换VConsole的方法
      }
    },

    // 切换VConsole显示状态
    switchShowVConsole() {
      const currentValue = localStorage.getItem('showVConsole');
      if (currentValue === '1') {
        localStorage.setItem('showVConsole', '0');
        this.showVConsole = false;
        // 如果VConsole实例存在，则销毁它
        if (window.vConsoleInstance) {
          window.vConsoleInstance.destroy();
          window.vConsoleInstance = null;
        }
      } else {
        localStorage.setItem('showVConsole', '1');
        // 初始化VConsole
        this.initVConsole();
      }
    },

    // 初始化VConsole
    initVConsole() {
      // 检查是否已经初始化了VConsole实例
      if (!window.vConsoleInstance) {
        this.showVConsole = true;
        // eslint-disable-next-line new-cap
        window.vConsoleInstance = new VConsole();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.oms-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  gap: 20px;

  .msg-icon {
    font-size: 22px;
    color: #ffffff;
    padding: 19px;
  }

  .debug-btn {
    width: 60px;
    height: 48px; /* 匹配 header 高度或给予足够点击区域 */
    cursor: pointer;
  }
}
</style>
